import * as THREE from 'three';

export const createDrone = (
    scene: THREE.Scene,
    materials: any,
    componentsRef: React.MutableRefObject<Array<{
        mesh: THREE.Mesh;
        solidMaterial: THREE.Material;
        wireframeMaterial: THREE.Material;
    }>>,
    droneRef: React.MutableRefObject<{
        group: THREE.Group;
        solidMaterial: THREE.Material;
        wireframeMaterial: THREE.Material;
        propellerMaterial: THREE.Material;
    } | null>,
    droneCameraRef: React.MutableRefObject<THREE.PerspectiveCamera | null>
) => {
    const droneGroup = new THREE.Group();
    droneGroup.position.set(-6, 8, -3);

    // 无人机主体
    const droneBodyGeometry = new THREE.BoxGeometry(1.5, 0.3, 1.5);
    const droneBodyMesh = new THREE.Mesh(droneBodyGeometry, materials.droneYellow.clone());
    droneGroup.add(droneBodyMesh);
    
    // 螺旋桨 (简化为小圆柱体)
    const propellerGeometry = new THREE.CylinderGeometry(0.1, 0.1, 0.5, 8);
    const propellerMaterial = new THREE.MeshStandardMaterial({ color: 0x303030, metalness: 0.8, roughness: 0.2 });

    const prop1 = new THREE.Mesh(propellerGeometry, propellerMaterial.clone());
    prop1.position.set(0.6, 0.3, 0.6);
    droneGroup.add(prop1);

    const prop2 = new THREE.Mesh(propellerGeometry, propellerMaterial.clone());
    prop2.position.set(-0.6, 0.3, 0.6);
    droneGroup.add(prop2);

    const prop3 = new THREE.Mesh(propellerGeometry, propellerMaterial.clone());
    prop3.position.set(0.6, 0.3, -0.6);
    droneGroup.add(prop3);

    const prop4 = new THREE.Mesh(propellerGeometry, propellerMaterial.clone());
    prop4.position.set(-0.6, 0.3, -0.6);
    droneGroup.add(prop4);

    scene.add(droneGroup);
    droneRef.current = {
        group: droneGroup,
        solidMaterial: materials.droneYellow.clone(),
        wireframeMaterial: materials.wireframeCyan.clone(),
        propellerMaterial: propellerMaterial.clone()
    };

    // 将无人机部件添加到 componentsRef 以便数字化
    componentsRef.current.push({
        mesh: droneBodyMesh,
        solidMaterial: materials.droneYellow.clone(),
        wireframeMaterial: materials.wireframeCyan.clone()
    });
    
    droneGroup.children.forEach(child => {
        if (child instanceof THREE.Mesh && child !== droneBodyMesh) {
            componentsRef.current.push({
                mesh: child,
                solidMaterial: (child.material as THREE.Material).clone(),
                wireframeMaterial: materials.wireframeCyan.clone()
            });
        }
    });

    // 创建无人机视角摄像机
    const droneCamera = new THREE.PerspectiveCamera(75, 1, 0.1, 100);
    droneCamera.position.set(0, -0.5, 0);
    droneCamera.lookAt(0, -10, 0);
    droneGroup.add(droneCamera);
    droneCameraRef.current = droneCamera;
}; 